import { defineMessages } from 'react-intl'

const messages = defineMessages({
  noAvailability: {
    id: 'detail.no-availability',
  },
  alreadyBooked: {
    id: 'step-error.already-booked',
  },
  availabilityExpired: {
    id: 'step-error.availability-expired',
  },
  // We use the same message as above but I leave a separate entry since it is actually a different error and
  // it's better to have a reference.
  noConfirm: {
    id: 'step-error.availability-expired',
  },
})

export default messages
